import React, { useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { getEmailFromClaims } from '../utils/claims';

const Profile = () => {
  const { accounts } = useMsal();
  const [userData, setUserData] = useState({});

  useEffect(() => {
    if (accounts.length > 0) {
      const account = accounts[0];
      // Email from the Vipps-sourced ID token claims — under Vipps,
      // account.username may be a GUID and must never be shown as an email.
      setUserData({
        name: account.name,
        email: getEmailFromClaims(account),
      });
    }
  }, [accounts]);

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Your Profile</h1>
      <div className="bg-gray-100 p-4 rounded-lg">
        <p><strong>Name:</strong> {userData.name || "N/A"}</p>
        {userData.email && (
          <p><strong>Email:</strong> {userData.email}</p>
        )}
      </div>
    </div>
  );
};

export default Profile;
